export default __webpack_public_path__ + "49d0dfccb2c7333add0c1277ce21fa1e.svg";